var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('Tabs2',{attrs:{"data":['基础属性', '表单操作权限'],"height":40,"tab":_vm.tab},on:{"on-tab":_vm.handleTab}}),(_vm.tab === 0)?_c('BaseInfo',{attrs:{"item":_vm.item},on:{"on-item":_vm.handleBaseInfo}}):_vm._e(),(_vm.tab === 1)?_c('FormList',{attrs:{"datas":_vm.fromPropertyList},on:{"on-list":_vm.handleFormList}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }